<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>账单列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form
                  v-if="resData"
                  :inline="true"
                  :model="form"
                  class="demo-form-inline"
                >
                  <el-form-item label="输入搜索：">
                    <el-select
                      v-model="form.pgid"
                      placeholder="选择代采组"
                      @change="setMemberOp"
                    >
                      <el-option label="全部" value></el-option>
                      <el-option
                        v-for="item in resData.optionPg"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-select
                    v-model="form.order_owner"
                    filterable
                    placeholder="订单负责人"
                  >
                    <el-option label="全部" value></el-option>
                    <el-option
                      v-for="item in resData.owner_option"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-form-item>
                    <el-input
                      v-model="form.supply_name"
                      placeholder="商家"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.woid"
                      placeholder="代采订单"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.bill_id"
                      placeholder="账单编号"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-select v-model="form.city" placeholder="城市">
                      <!--<el-option label="全部" value=""></el-option>-->
                      <el-option
                        v-for="item in resData.origin"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item>
                    <el-input
                      v-model="form.market_name"
                      placeholder="市场"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-input
                      v-model="form.pay_admin"
                      placeholder="支付人"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="form.status" placeholder="状态">
                      <el-option label="全部" value></el-option>
                      <el-option
                        v-for="item in resData.statusArr"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item>
                    <el-select v-model="form.bill_type" placeholder="分账类型">
                      <el-option label="全部" value></el-option>
                      <el-option
                        v-for="item in resData.types"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="form.pay_tool" placeholder="支付方式">
                      <el-option label="全部" value></el-option>
                      <el-option
                        v-for="item in resData.optionPayTools"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.bill_merger_date"
                      placeholder="前置仓合并账单日期"
                    >
                      <el-option label="全部" value></el-option>
                      <el-option
                        v-for="item in resData.dates"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.is_dispense"
                      placeholder="小店分发"
                    >
                      <el-option label="全部" value="0"></el-option>
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
            <div style="padding: 0 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="账单日期：">
                  <el-date-picker
                    v-model="form.settle_period"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding: 0 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="结账日期：">
                  <el-date-picker
                    v-model="form.pay_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
            position: relative;
          "
        >
          <div>数据列表：</div>
          <div style="position: absolute; top: 10px; right: 10px">
            <el-button
              style="margin-left: auto"
              type="warning"
              size="mini"
              @click="handleActiveBill"
              >批量激活</el-button
            >
            <el-button
              style="margin-left: auto"
              type="warning"
              size="mini"
              @click="handleSubmitBill"
              >批量提交</el-button
            >
            <el-button
              style="margin-left: auto"
              type="warning"
              size="mini"
              @click="batchAudit"
              >批量审核</el-button
            >
            <el-button
              style="margin-left: auto"
              type="warning"
              size="mini"
              @click="mergeBill"
              >合并账单</el-button
            >
            <el-button
              style="margin-left: auto"
              type="primary"
              size="mini"
              @click="showPayBox"
              >账单转账/分账</el-button
            >
            <el-button
              style="margin-left: auto"
              type="success"
              size="mini"
              @click="output(2)"
              >导出商品明细</el-button
            >
            <el-button
              style="margin-left: auto"
              type="success"
              size="mini"
              @click="output(3)"
              >导出商品明细(新)</el-button
            >
            <el-button style type="success" size="mini" @click="output(1)">
              导出列表</el-button
            >
          </div>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.data"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              type="selection"
              width="55"
              :selectable="checkboxInit"
            ></el-table-column>

            <el-table-column
              prop="settle_period"
              label="账单日期"
              show-overflow-tooltip
              align="center"
              width="170"
            ></el-table-column>
            <el-table-column
              prop="bill_id"
              label="账单编号"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              label="分账类型"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.supply_settle_bill_bill_type }}</p>
                <p style="color: #2d59ec; font-size: 14px; line-height: 0">
                  {{ scope.row.is_dispense_label }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              prop="supply_settle_bill_pay_tool"
              label="支付方式"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家名称"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="order_num"
              label="涉及订单数"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="city"
              label="城市"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="market_name"
              label="市场"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="owner_admin_name"
              label="订单负责人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="real_pay"
              label="开单"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope"
                >{{ scope.row.se_pay_num }}/{{
                  scope.row.se_pay_amount
                }}</template
              >
            </el-table-column>
            <el-table-column
              prop="activity_price"
              label="活动服务费"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="service_fee"
              label="佣金"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dispense_commission_amount"
              label="小店佣金"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="refund_service_fee"
              label="退货服务费"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="real_pay_with_ded"
              label="实付金额"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ded_activity_fee"
              label="活动费用抵扣金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="return_profit_fee"
              label="让利佣金抵扣金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="use_ded_amount"
              label="使用抵扣商品"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="real_pay"
              label="实际结算"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope"
                >{{ scope.row.se_pay_num }}/{{ scope.row.real_pay }}</template
              >
            </el-table-column>
            <el-table-column
              prop="status"
              label="账单状态"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.status == '已驳回'" style="color: red">
                  {{ scope.row.status }}
                </span>
                <span v-else>{{ scope.row.status }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="admin_name"
              label="支付人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="pay_time"
              label="支付时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="owe_time"
              label="回货单日期"
              show-overflow-tooltip
              align="center"
              width="200"
            ></el-table-column>
            <el-table-column
              label="操作"
              show-overflow-tooltip
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleDetail(scope.row)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :page-sizes="[10, 50, 100, 200, 500, 1000]"
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.total"
            :page-size="form.page_size"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </el-col>
    </el-row>
    <div v-if="payVisible">
      <pay-tem
        :ids="bill_ids"
        :url="url2"
        :pay_num="pay_num"
        :pay_money="pay_money"
        @onCloseDialog="onCloseDialog"
      ></pay-tem>
    </div>
  </div>
</template>

<script>
import PayTem from "../wcgorder/components/PayOrderTem.vue";
import { batchCommit } from "@/controller/finance.js";
import { checkIsCanRepay, repayByBillIds } from "@/controller/finance2418.js";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: {
    PayTem,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      BILL_TYPES: {
        GOODS_BEFORE_PAY_AFTER: 0, // 先货后款
        FRONT_WAREHOUSE: 1, // 前置仓
        NORMAL_TAKE_GOODS: 2, // 常规拿货
        ALLOTMENT: 3, // 配发出库
      },
      resData: null,
      form: {
        pagesize: 100,
        settle_period: this.defaultDate(),
        page_size: 10,
        is_dispense: "",
      },
      loading: false,
      url: "/erp/SupplySettleBill/getList",
      url2: "/erp/SupplySettleBill/payOrder",
      where: -1,
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      pay_num: 0,
      pay_money: 0,
      bill_ids: [],
      payVisible: false,
      optionPgMember: [],
    };
  },
  computed: {
    filteredForm() {
      const { form } = this;
      Object.keys(form).forEach((key) => {
        if (form[key] === undefined || form[key] === "" || form[key] === null) {
          delete form[key];
        }
      });
      return form;
    },
  },
  // created() {
  //   this.fetchData();
  // },
  methods: {
    handlePay() {
      if (this.pay_num === 0) {
        this.$message.error("请选择订单");
      } else {
        this.loading = true;
        this.$http
          .post("/erp/SupplySettleBill/payOrder", {
            ids: this.bill_ids,
            furinfo: "代用户支付服装商家货款",
          })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success(res.data.msg);
              this.fetchData();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    setMemberOp(value) {
      this.optionPgMember = [];
      for (const key in this.resData.optionPgMember) {
        if (value == this.resData.optionPgMember[key].pgid) {
          this.optionPgMember.push(this.resData.optionPgMember[key]);
        }
      }
    },
    onCloseDialog() {
      this.payVisible = false;
      this.fetchData();
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 3);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    output(type) {
      this.form.is_excel = type;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    checkboxInit() {
      return 1;
      // console.log(row, index);
      // 常规拿货的不能勾选合并账单
      // return row.bill_type != 2;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.pay_num = 0;
      this.pay_money = 0.0;
      const multipleSelection = [];

      Object.keys(val).forEach((key) => {
        this.pay_num += 1;
        this.pay_money += parseFloat(val[key].real_pay);
        multipleSelection[key] = val[key].bill_id;
      });

      this.bill_ids = multipleSelection;
    },
    onSubmit() {},
    handleDetail(row) {
      const t = Date.parse(new Date());
      this.$router.push(`/home/OkSupplyBillDetail/${row.bill_id}?t=${t}`);
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleClick(row, index) {
      const curRow = this.resData.list[index];
      this.$router.push(
        `/home/stockdetail/${row.goods_no}?co_id=${curRow.co_id}&where=${curRow.where}&si_id=${curRow.si_id}`
      );
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.origin = this.filteredForm.origin;
          this.where = this.filteredForm.where;
          this.curPage = 1;
        }
      });
    },
    selectOrigin(key) {
      this.form.origin = key;
      this.origin = key;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    selectWhere(key) {
      this.form.where = key;
      this.where = key;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSizeChange(e) {
      this.form.page_size = e;
      this.fetchData();
    },
    mergeBill() {
      this.$confirm("确定需要合并账单？", "提示", {
        center: true,
      })
        .then(() => {
          this.$http
            .post("/erp/SupplySettleBill/mergeBill", {
              billIds: this.bill_ids,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
                return;
              }
              this.$message.success("操作成功");
              this.fetchData();
            });
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    // 批量审核
    batchAudit() {
      if (this.bill_ids.length < 1) {
        this.$message({
          message: "请勾选需要批量审核的前置仓单据",
          type: "error",
        });
        return;
      }
      this.$confirm("确定批量通过审核？", "提示", {
        center: true,
      })
        .then(() => {
          this.$http
            .post("/erp/SupplySettle/batchCheckPreStoragePassBill", {
              bill_ids: this.bill_ids,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
                return;
              }
              const { num = 0 } = res.data.data;
              if (num) {
                this.$message.success(`审核成功${num}条`);
              }
              this.fetchData();
            });
        })
        .catch(() => {
          this.$message.info("已取消审核");
        });
    },
    // 批量提交账单
    handleSubmitBill() {
      if (this.bill_ids.length < 1) {
        this.$message({
          message: "请勾选需要批量提交的账单",
          type: "error",
        });
        return;
      }
      this.$confirm("确定批量提交？", "提示", {
        center: true,
      })
        .then(() => {
          batchCommit(
            { bill_ids: this.bill_ids },
            { useDataField: false }
          ).then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
              return;
            }
            this.$message.success(res.data.msg);

            this.fetchData();
          });
        })
        .catch(() => {
          this.$message.info("已取消提交账单");
        });
    },
    handleActiveBill() {
      if (this.bill_ids.length < 1) {
        this.$message({
          message: "请选择账单",
          type: "error",
        });
        return;
      }
      const message = `已选中账单：${this.bill_ids.length}，确认重新激活？`;
      const title = "提示";
      this.$confirm(message, title, {
        center: true,
      })
        .then(async () => {
          try {
            await checkIsCanRepay({
              bill_ids: this.bill_ids.join(","),
            });
            const repayByBillIdsMsg = await repayByBillIds({
              bill_ids: this.bill_ids.join(","),
            });
            this.$message.success(repayByBillIdsMsg);
            this.fetchData();
          } catch (err) {
            console.log(err);
          }
        })
        .catch(this.$noop);
    },
    showPayBox() {
      if (this.bill_ids.length < 1) {
        this.$message.error("请选择付款账单");
        return;
      }
      this.$http
        .post("/erp/SupplySettleBill/judgeBillCanPay", {
          bill_ids: this.bill_ids,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
            return;
          }
          if (this.pay_money) {
            this.payVisible = true;
          } else {
            this.handlePay();
          }
        });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/supplybill/OkSupplyBill.vue